module.exports = __webpack_public_path__ + "img/search-sm.8200b209.svg";